import MapAdapter from "../../gutenberg/blocks/location-finder/modules/MapAdapter";
import MapMarkerAdapter from "../../gutenberg/blocks/location-finder/modules/MapMarkerAdapter";

const { themeURL } = window.WP_VARS;

const container = document.getElementById("single-gmap-container");

const coordinates = window.LOCATION.coordinates;

const lat = parseFloat(coordinates.lat);
const lng = parseFloat(coordinates.lng);

const map = new MapAdapter({
  container,
  center: { lat, lng },
  zoom: 16,
  zoomControl: false,
  mapTypeControl: false,
  scaleControl: false,
  streetViewControl: false,
  rotateControl: false,
  fullscreenControl: false,
});

window.initMap = () => {
  map.init();

  // add marker
  new MapMarkerAdapter({
    lat,
    lng,
    icon: {
      url: `${themeURL}/icons/marker.svg`,
      scaledSize: new google.maps.Size(28, 37),
    },
    // animationDelay: 500,
    map: map.getInstance(),
    usePopup: false,
  });
};
